import { useEffect } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../../api/get-user';
import { ActiveAuthForm } from '../../../../store/auth/enum/active-auth-form';
import { RegisterRole } from '../../../../store/auth/enum/register-role';
import { createSetActiveAuthForm, createSetCurrentUser, createSetRegisterRole } from '../../../../store/auth/factory';
import { getActiveAuthFormSelector } from '../../../../store/auth/selector';
import { createSetTaModalbAction, setMenuModalAction, setModalAction } from '../../../../store/modal/factory';
import { ActiveModal } from '../../../enums/active-modal';
import { StartupOpenModal } from '../../../enums/startup-open-modal';

export function useViewModel() {
  const dispatch = useDispatch();
  const activeForm = useSelector(getActiveAuthFormSelector);

  const modal = useSelector((state: { modal: { activeModal: ActiveModal } }) => state.modal.activeModal);

  const modalCloseHandler = () => dispatch(setModalAction(ActiveModal.NONE));

  const showFeedbackHandler = () => dispatch(setMenuModalAction(ActiveModal.FEEDBACK));

  const showModalHandler = () => dispatch(setMenuModalAction(ActiveModal.MENU));

  const loginModalHandler = () =>
    batch(() => {
      dispatch(createSetActiveAuthForm(ActiveAuthForm.LOGIN));
      dispatch(createSetTaModalbAction(ActiveModal.LOGIN));
    });

  const roleModalHandler = () => dispatch(setModalAction(ActiveModal.ROLE));

  const chooseRoleHandler = (role: string) =>
    batch(() => {
      dispatch(setModalAction(ActiveModal.LOGIN));
      dispatch(createSetActiveAuthForm(ActiveAuthForm.REGISTER));
      dispatch(createSetRegisterRole(role as RegisterRole));
    });

  const changeTabHandler = (tab: string) => {
    if (tab === ActiveAuthForm.REGISTER) {
      return dispatch(setModalAction(ActiveModal.ROLE));
    }

    dispatch(createSetActiveAuthForm(tab as ActiveAuthForm));
  };

  useEffect(() => {
    getUser()
      .then(user => dispatch(createSetCurrentUser(user)))
      .catch(console.log);

    const url = new URL(document.location.href);
    const openParam = url.searchParams.get('open');
    switch (openParam) {
      case StartupOpenModal.LOGIN:
        loginModalHandler();
        break;
      case StartupOpenModal.REGISTER:
        roleModalHandler();
        break;
    }
  }, []);

  return {
    activeForm,
    changeTabHandler,
    modalCloseHandler,
    chooseRoleHandler,
    roleModalHandler,
    loginModalHandler,
    showFeedbackHandler,
    showModalHandler,
    modal,
  };
}
